import React, { useCallback, useEffect, useState } from 'react'
import styled from 'styled-components'
import LobbyEntry from '../components/LobbyEntry'
import LobbyOverlay from '../components/LobbyOverlay'
import PageWithBg from '../components/PageWithBg'
import config from '../config'
import Amplitude from '../utils/amplitudeHelper'
import LoadIcon from '../components/LoadIcon'
import fingerIcon from '../images/backdrops/finger.png'
import { useDispatch } from 'react-redux'
import { showGlobalModal } from '../ducks/layout'
import { toast } from 'react-toastify'

const PageWrapper = styled.div`
  .trailer {
    background-color: #fdf9f8;
    position: absolute;
    top: 15.2%;
    left: 40.5%;
    right: 38.7%;
    bottom: 64%;
  }
  #game-stand {
    cursor: pointer;
    position: absolute;
    top: 50%;
    bottom: 29%;
    right: 86.9%;
    left: 8.5%;
  }
  #finger {
    position: absolute;
    left: 11.5%;
    bottom: 38%;
    transition: 100ms ease-in;
    animation: mousepoint 1500ms infinite;
  }
  #current-user {
    pointer-events: none;
    position: absolute;
    right: 5px;
    bottom: 5px;
    font-size: 10px;
    color: gray;
  }
  #banner {
    position: absolute;
    cursor: pointer;
    top: 41.3%;
    bottom: 35.1%;
    left: 47.3%;
    right: 45.1%;
  }
`

export default function LobbyPage({ currentUser }) {
  const dispatch = useDispatch()
  const [overlayTitle, setOverlayTitle] = useState('Select hall to enter:')
  const [overlay, setOverlay] = useState(null)
  const [isLoading, setIsLoading] = useState(true)

  const showEntryOverlay = (destinations) => {
    setOverlay(destinations)
  }

  const hideOverlay = () => setOverlay(null)

  const escFunction = useCallback((event) => {
    if (event.keyCode === 27) {
      hideOverlay()
    }
  }, [])

  const showHelpDesk = () => {
    // const cpt = window.chaport
    // cpt.on('ready', function () {
    //   cpt.setVisitorData({
    //     name: currentUser.fullName,
    //     email: currentUser.email,
    //   })
    //   cpt.open()
    // })
    // cpt.on('collapsed', function () {
    //   cpt.close()
    // })
    toast("The help desk is closed as the event has ended.")
    Amplitude.clickHelpDesk()
  }

  useEffect(() => {
    document.title = `${config.eventName} | Lobby`
  }, [])

  useEffect(() => {
    Amplitude.visit('Lobby')
  }, [currentUser.id])

  useEffect(() => {
    document.addEventListener('keydown', escFunction, false)

    return () => {
      document.removeEventListener('keydown', escFunction, false)
    }
  }, [escFunction])

  const toggleModal = () => {
    dispatch(showGlobalModal('quiz'))
    Amplitude.showQuizInstruction()
  }

  return (
    <>
      {isLoading && <LoadIcon />}
      <PageWrapper style={{ opacity: isLoading ? 0 : 1 }}>
        <PageWithBg bgImg={config.assets.lobby.landscape}>
          <LobbyOverlay overlayTitle={overlayTitle} overlay={overlay} hideOverlay={hideOverlay} />
          {config.lobbyEntries.map((entry) => {
            return <LobbyEntry showHelpDesk={showHelpDesk} key={entry.id} setOverlayTitle={setOverlayTitle} showEntryOverlay={showEntryOverlay} {...entry} />
          })}
          <div id="game-stand" onClick={toggleModal}></div>
          <img id="finger" src={fingerIcon} width="50px" alt="pointer"/>
          <div className="trailer">
            <iframe
              width="100%"
              height="100%"
              title="Lobby Vimeo"
              src="https://player.vimeo.com/video/573004542?quality=360p&autoplay=1&loop=1"
              allow="autoplay; fullscreen"
              allowFullScreen
              frameBorder="0"
              onLoad={() => {
                setIsLoading(false)
              }}
            />
          </div>
          <div id="current-user">Logged in as {currentUser.email}</div>
        </PageWithBg>
      </PageWrapper>
    </>
  )
}
